import React, { FC } from 'react';
import cn from 'classnames';

import { DatePicker as AntDatePicker } from 'antd';
import { DatePickerProps, RangePickerProps } from 'antd/lib/date-picker';
import { CalendarIcon } from '@revfluence/fresh-icons/regular';

import styles from './DatePicker.module.scss';

import { RangePicker } from './RangePicker';

export type TDatePickerProps = DatePickerProps;

type TDatePicker = React.FC<TDatePickerProps> & {
  RangePicker: FC<RangePickerProps>;
};

export const DatePicker: TDatePicker = ({
  className,
  suffixIcon = <CalendarIcon />,
  ...props
}) => (
  <AntDatePicker
    className={cn(styles.DatePicker, className)}
    suffixIcon={suffixIcon}
    {...props}
  />
);

DatePicker.RangePicker = RangePicker;
